<template lang="pug">
UiStack(vertical)
  UiStack
    UiStackItem(fill)
      .ui-card-section-title {{ $t("companies.approvers.approval_flow") }}
    UiStackItem
      UiButton(
        variant="primary"
        @click="importApprovalSettings"
        icon="FileDownload"
      ) {{ $t("companies.import") }}
    UiStackItem
      UiButton(
        variant="primary"
        @click="exportApprovalSettings"
        icon="FileDownload"
      ) {{ $t("companies.export_to_excel") }}
  RestTable(
    :disable-pagination="true"
    namespace="approval_flow"
    :headers="headers"
    ref="approvalFlowTable"
    :fetch-handler="getData"
    embed
  )
    template(#cell:name="{ item }")
      UiStack(spacing="xs")
        UiStackItem
          | {{ APPROVAL_FLOWS[item.name] }}
    template(#cell:_no_label_columns="{ item }")
      UiStack(spacing="xs")
        UiStack(spacing="xs")
          UiStackItem
            UiButton(
              size="sm"
              variant="smooth-primary"
              @click="upApprovalFlow(item)"
              icon="ArrowTop"
            ) Up
          UiStackItem
            UiButton(
              size="sm"
              variant="smooth-primary"
              @click="downApprovalFlow(item)"
              icon="ArrowBottom"
            ) Down
        UiCheckbox(
          v-model="item.is_active"
          switch
          @update:modelValue="changeEnabled(item)"
        )
  ImportApproversModal(
    ref="ImportApproversModal"
    @done="reload"
  )
</template>

<script>
import ApiApprovers from "@/api/approvers.js";
import PriceLimitForm from "@/views/Approvers/default_price_form.vue";
import ImportApproversModal from "@/modals/Approvers/import.vue";

const APPROVAL_FLOWS = {
  vendor: "Default factual verificator and approver by vendor",
  vendor_approver: "Default approver by vendor",
  vendor_verificator: "Default factual verificator by vendor",
  account: "Default factual verificator and approver by account",
  account_approver: "Default approver by account",
  account_verificator: "Default factual verificator by account",
  price: "Default approver by price",
  company: "Default factual verificator and approver by company",
  company_approver: "Default approver by company",
  company_verificator: "Default factual verificator by company",
  cost_center: "Default factual verificator and approver by cost center",
  cost_center_approver: "Default approver by cost center",
  cost_center_verificator: "Default factual verificator by cost center",
};

export default {
  components: {
    PriceLimitForm,
    ImportApproversModal,
  },

  data() {
    return {
      APPROVAL_FLOWS: APPROVAL_FLOWS,
      active_flow_list: [],
      list_headers: [
        {
          key: "name",
          label: "Name",
          squeeze: true,
        },
        {
          key: "actions",
          label: "",
          squeeze: true,
        },
      ],
      headers: [
        {
          key: "sort",
          label: "#",
          squeeze: true,
        },
        {
          key: "name",
          label: "Active Flow",
          squeeze: true,
          cellStyle: {
            "white-space": "nowrap",
          },
        },
        {
          key: "_no_label_columns",
          label: "",
        },
      ],
    };
  },

  methods: {
    createApprovalFlow(item) {
      ApiApprovers.createApprovalFlow(this.$route.params.id, {
        approval_flow: { name: item.name },
      }).then((resp) => {
        this.reload();
      });
    },
    deleteApprovalFlow(item) {
      ApiApprovers.deleteApprovalFlow(this.$route.params.id, item.id).then(
        (resp) => {
          this.reload();
        },
      );
    },

    changeEnabled(item) {
      if (item.is_active) {
        this.createApprovalFlow(item);
      } else {
        this.deleteApprovalFlow(item);
      }
    },

    reload() {
      this.$refs.approvalFlowTable.fetchData();
    },
    downApprovalFlow(item) {
      return new Promise((res) => {
        ApiApprovers.downApprovalFlow(this.$route.params.id, item.id).then(
          (resp) => {
            this.reload();
          },
        );
      });
    },
    upApprovalFlow(item) {
      return new Promise((res) => {
        ApiApprovers.upApprovalFlow(this.$route.params.id, item.id).then(
          (resp) => {
            this.reload();
          },
        );
      });
    },
    getList() {
      return new Promise((res) => {
        res({
          items: this.approvalFlowList(),
        });
      });
    },

    exportApprovalSettings() {
      ApiApprovers.exportApprovalSettings(this.$route.params.id)
        .then((resp) => {
          let fileURL = window.URL.createObjectURL(new Blob([resp.data]));
          let fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", `approval_settings.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch((e) => {});
    },

    importApprovalSettings() {
      this.$refs.ImportApproversModal.open(this.$route.params.id);
    },

    getData(params, config) {
      return ApiApprovers.fetchApprovalFlows(
        this.$route.params.id,
        params,
        config,
      ).then((resp) => {
        this.active_flow_list = resp.data.approval_flows.map((x) => x.name);

        let list = this.approvalFlowList();

        let activeFlows = resp.data.approval_flows;
        activeFlows = activeFlows.map((flow) => ({
          id: flow.id,
          name: flow.name,
          displayName: APPROVAL_FLOWS[flow.name],
          is_active: true,
          sort: flow.sort,
        }));
        return {
          items: activeFlows.concat(list),
        };
      });
    },

    approvalFlowList() {
      const all_approval_flows = Object.keys(APPROVAL_FLOWS);
      const to_remove = new Set(this.active_flow_list);
      let non_active_approval_flow = all_approval_flows.filter(
        (x) => !to_remove.has(x),
      );
      let list = non_active_approval_flow.map((key) => ({
        name: key,
        displayName: APPROVAL_FLOWS[key],
        is_active: false,
      }));
      return list;
    },
  },
};
</script>
